

























import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ILabel from "../types/label";

@Component
export default class LabelSelector extends Vue {
  @Prop() value!: ILabel[];
  @Prop(Array) items!: ILabel[];
  @Prop({ default: "" }) searchQuery!: string | null;

  itemIsFound(label: ILabel) {
    if (!this.searchQuery) return true;

    const sq = this.searchQuery.toLowerCase();

    return (
      label.name.toLowerCase().includes(sq) ||
      label.aliases.some((name) => name.toLowerCase().includes(sq))
    );
  }

  innerValue = (this.value.length ? this.value : []) as ILabel[];

  @Watch("value", { deep: true })
  onValueChange(newVal: ILabel[]) {
    this.innerValue = newVal;
  }

  labelAliases(label: ILabel) {
    return label.aliases.slice().sort().join(", ");
  }

  @Watch("innerValue", { deep: true })
  onInnerValueChange() {
    this.$emit("input", this.innerValue);
  }
}
